'use es6';

import WeekCalendarWrapper from './WeekCalendarWrapper';
export default WeekCalendarWrapper;